module.exports = __webpack_public_path__ + "static/img/fefco712_1.f21c02d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco712_1.png
// module id = nOVq
// module chunks = 0